import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { from } from 'rxjs';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { AgGridModule } from 'ag-grid-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TransitionRoutingModule } from './transition-routing.module';
import { ExpenseStatementComponent } from './expensestatement/expensestatement.component';
import { AddRouteMasterComponent } from './addroutemaster/addroutemaster.component';
import { EditRouteListComponent } from './editroutelist/editroutelist.component';
import { AddTourProgramComponent } from './addtourprogram/addtourprogram.component';
import { EditTourProgramComponent } from './edittourprogram/edittourprogram.component';
import { DCRComponent } from './dcr/dcr.component';
// import { NgSelectModule } from '@ng-select/ng-select';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { CellDropDownRendererComponent } from '../Validation/CellDropDownRendererComponent.component'

@NgModule({
    imports: [
        CommonModule,
        // NgSelectModule,
        NgMultiSelectDropDownModule,
        NgbModule,
        AgGridModule.withComponents([CellDropDownRendererComponent]),
        TransitionRoutingModule,
        FormsModule,
        GooglePlaceModule,
        ReactiveFormsModule
    ],
    declarations: [
        ExpenseStatementComponent,
        AddRouteMasterComponent,
        EditRouteListComponent,
        AddTourProgramComponent,
        EditTourProgramComponent,
        DCRComponent,
        CellDropDownRendererComponent
    ],
    providers: [],
    exports: [
        RouterModule, 
        // NgSelectModule,
        NgMultiSelectDropDownModule,
        FormsModule,
        AgGridModule
    ]
})
export class TransitionModule {

}
